import { Pipe, PipeTransform } from '@angular/core';
import { HtmlFragmentPipe } from './html-fragment';

@Pipe({
  name: 'appInnerHtml',
  pure: true
})
export class InnerHtmlPipe extends HtmlFragmentPipe implements PipeTransform {
  constructor() { super(); }

  transform(str: string): string {
    return this.fragment.innerHTML = str;
  }
}
